<template>
  <div>
    <Head :leftarrow="true" :lroute="backs"></Head>
    <div class="me-center" >
      <div>
        <van-row align="center" class="u-1" >
          <van-col span="24">
            <img :src="user.headpic" class="u-headpic" v-if="user.headpic"/>
            <img :src="defaultpic" class="u-headpic" v-else/>
            <span class="u-nickname">{{user.nickname}}</span>
          </van-col>
        </van-row>
      </div>

      <div class="confirm_mobile">
        <div class="title">
          设置手机号
        </div>
        <div class=" tip">
          <p>购票成功后，会收到取票码短信</p>
        </div>
        <van-cell-group style="margin-top:15px">
            <van-field type="phone" v-model.trim="user.mobile" placeholder="请输入新的手机号"/>
            <van-field placeholder="请输入短信验证码"  v-model="smscode" required clearable  use-button-slot>
              <van-button  v-show="sendAuthCode" slot="button" size="small" type="primary" @click="getVerifyCode" >发送验证码</van-button>
              <van-button  v-show="!sendAuthCode" slot="button" disabled size="small" type="primary" >{{auth_time}}秒</van-button>
            </van-field>
        </van-cell-group>
      </div>  
      <div class="z-bottom2">
        <div class="clful-btn"  v-if="user.mobile">
          <van-button size="large" type="primary" @click="register" >确认授权</van-button>
        </div>
        <div class="clful-btn"  v-else>
          <van-button size="large" type="primary" disabled >确认授权</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .u-1{
    height: 170px;
  }
  .u-headpic{
    width: 85px;
    height: 85px;
    border-radius: 50%;
    object-fit: cover;
    margin: 20px auto;
    border:2px solid #c02b61;
    display: block;
  }

  .u-nickname{
    color: #000;
    font-weight: bold;
    display: block;
    margin: 0 auto;
    text-align: center
  }
  .confirm_mobile{
    padding: 25px;
  }
  .z-bottom2 {
      background-color: rgb(255, 255, 255);
      width: 90%;
      margin: 0 auto;
  }

  .title{
	  font-size: 16px;
	  color:#333;
  }

  .tip p{
	  font-size: 12px;
	  color:#7d7e80;
	  line-height: 20px;
	  margin: 0;
  }

  .clful-btn{
    width: 95%;
    margin: 0 auto 20px;
  }
  .clful-btn button.van-button--primary{
    font-size: 16px;
    color: #fff;
    background-image: linear-gradient(to right , #d76f6b, #c02b61);
    border-radius:5px;
    padding: 0 5px;
    border: none;
    background-color: transparent
  }
</style>
<script>
import Head from '@/components/Head.vue'
import { Dialog,Toast } from 'vant';
import http from '../http.js';

  export default {
    metaInfo: {
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0, viewport-fit=cover' }
        ]
    },
    data(){
      return{
        token:'',
        user:{
          wecha_id : '',
          nickname : '',
          headpic : '',
          mobile : '',
        },
        defaultpic: require('../assets/2.jpg'),
        smscode:'',
        sendAuthCode:true,
        auth_time: 0
      }
    },
    components: {
      Head
    },
    beforeCreate() {

        var self = this;
        var code = http.getUrlParam('code');

        if (!code) {
          Dialog.alert({
              message: '获取授权失败',
              title:'提示'
          }).then(() => {
              this.$router.push({name:'n'});
          });
        } else {
            this.$http.post(this.$burl+'&c=login&m=wxcodelogin',{code:code})
            .then(res=>{
              if(res.status == 1 ){
                self.token = res.data.token;
                self.user = res.data.user;

                //alert('token='+ self.token+"\n"+'wecha_id='+ self.user.wecha_id +"\n"+'nickname='+ self.user.nickname+"\n"+'mobile='+ self.user.mobile+"\n");

                if(self.token != null && self.token != ''){
                    self.login();
                }
                
              }else{
                Dialog.alert({
                    message: res.message,
                    title:'提示'
                }).then(() => {
                   // this.$router.push({name:'n'});
                });
              }
            });
        }
        
    },
    mounted() {

    },

    methods:{
      backs(){
          this.$router.go(-1)
          return true;
      },
      getQuery(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
      },

      getVerifyCode(){

        if(!this.user.mobile) {
          Toast({ message: "手机号码不能为空", duration: 1000, forbidClick: true });
          return false
        } else if(!/^1[345678]\d{9}$/.test(this.user.mobile)) {
          Toast({ message: "手机号码格式不正确", duration: 1000, forbidClick: true });
          return false
        } else {
        
          var obj=this;
          obj.validateBtn();
          this.$http.post(this.$burl+'&c=movient&m=getyzm',{mobile:obj.user.mobile}).then((res) => {
          });
        }
        

      },

      validateBtn(){
        this.sendAuthCode = false;
        this.auth_time = 60;
        var auth_timetimer =  setInterval(()=>{
          this.auth_time--;
          if(this.auth_time<=0){
            this.sendAuthCode = true;
            clearInterval(auth_timetimer);
          }
        }, 1000);
      },

      login(){
          let self = this;

          this.$store.commit('changeLogin',{state:'1',token:self.token,'userinfo':self.user});
          this.$router.push({name:'n'});
      },
      register(){
        let self = this;
        
        if(!this.user.mobile) {
          Toast({ message: "手机号码不能为空", duration: 1000, forbidClick: true });
          return false
        } else if(!/^1[345678]\d{9}$/.test(this.user.mobile)) {
          Toast({ message: "手机号码格式不正确", duration: 1000, forbidClick: true });
          return false
        }else if(!this.smscode) {
          Toast({ message: "短信验证码不能为空", duration: 1000, forbidClick: true });
          return false
        } else {
          this.$http.post(this.$burl+'&c=login&m=wxregister',{wecha_id:this.user.wecha_id, nickname:this.user.nickname,headpic:this.user.headpic, mobile:this.user.mobile,smscode:this.smscode})
          .then((res)=>{
              if(res.status == 1){
                self.$store.commit('changeLogin',{state:'1',token:res.data.token,'userinfo':res.data.user});
                self.$router.push({name:'n'});
              }else{
                Dialog.alert({
                    message: res.message,
                    title:'提示'
                }).then(() => {
                });
              }
          }).catch(()=>{})
        }
      }
    },
    computed:{
 
    }
  }
  
</script>